import { Grid, Stack } from "@mui/material";
import useFetch from "../../../../hooks/useFetch";
import { useCallback, useEffect, useState } from "react";
import { useFormContext } from "react-hook-form";
import { TAppointment } from "../../NewTriage/schema";
import { useTriageContext } from "../../../../store/contexts/TriageContext/TriageContext";
import EmergencyCareCardIndividual from "../../../../components/VirtualEmergencyCare/EmergencyCareCardIndividual";
import { FamilyGroupService } from "../../../Schedule/FamilyGroup/familyGroup.service";
import { IFamilyMember } from "../model";

const TriageSelectBeneficiary = ({
  onSelectBeneficiary,
}: {
  onSelectBeneficiary: (name: string, individualId: string) => void;
}) => {
  const [beneficiaries, setBeneficiaries] = useState<IFamilyMember[]>([]);

  const { onChangePatient, onActiveStep } = useTriageContext();

  const { setValue } = useFormContext<TAppointment>();

  const { sendRequest } = useFetch(FamilyGroupService.get);

  const loadBeneficiaries = useCallback(async () => {
    const { data, success } = await sendRequest(null);
    if (success) {
      setBeneficiaries(data);
    }
  }, [sendRequest]);

  useEffect(() => {
    loadBeneficiaries();
  }, [loadBeneficiaries]);

  const selectBeneficiaryHandler = (name: string, individualId: string) => {
    onSelectBeneficiary(name, individualId);
    onChangePatient({
      name,
      id: individualId,
    });
    setValue("patient", {
      name,
      id: individualId,
      individualId,
    });

    onActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  return (
    <>
      <Grid container gap={2}>
        <Grid sm={12} mt={2}>
          <Stack
            display={"flex"}
            flexDirection={"row"}
            flexWrap={"wrap"}
            gap={2}
          >
            {beneficiaries?.map((beneficiary) => (
              <EmergencyCareCardIndividual
                padding={1}
                individual={beneficiary.individual}
                onClick={() =>
                  selectBeneficiaryHandler(
                    beneficiary.individual.name,
                    beneficiary.individual.id
                  )
                }
              />
            ))}
          </Stack>
        </Grid>
      </Grid>
    </>
  );
};

export default TriageSelectBeneficiary;
